
import { executeCoingecko } from './executeCoingecko'


/**
 * PROXY REQUEST PARAMS
 *
 * Use 'proxyBackendUrl'
 */
export const proxyRequests = {
  
  executeCoingecko
}